import React, { useContext, useState } from "react";
import { exportToXLSX } from "./exportUtils";
import AuthContext from "../../context/auth/authContext";
import setAuthToken from "../../functions/auth_header";
import { getAppUrl } from "../../functions/getEnv";
import AdminLeloContext from "../../context/adminLelo/adminLeloContext";
import axios from "axios";
import { toast } from "react-toastify";

const ExportExcelButton = ({ 
  getCurrentFilters, 
  appUrl: reactAppUrl, 
  onExportStart, 
  onExportComplete 
}) => {
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const adminLeloContext = useContext(AdminLeloContext);
  const {
    getLeloEntriesOptimize,
    searchText,
    startDate,
    endDate
  } = adminLeloContext;

  const [isExporting, setIsExporting] = useState(false);
  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      
      
      // Call parent's onExportStart callback to show the message
      if (onExportStart) {
        onExportStart();
        toast.success("Export to Excel initiated successfully");
      }

      // Get current filter parameters
      const filters = getCurrentFilters();
      // Fetch data from backend with current filters
      const exportData = await getLeloEntriesOptimize({
        status: filters.status,
        permaLink: filters.permaLink,
        startDate,
        endDate,
        searchText,
      });

      const dataToExport = Array.isArray(exportData)
        ? exportData.map((item) => ({
          ...item,
          PermaLink: `${reactAppUrl}/forms/${item.permaLink}/${item._uuid}`,
        }))
        : [];

      if (dataToExport.length === 0) {
        toast.error("No data available to export with the current filters.");
        return;
      }

      // Export to Excel
      exportToXLSX(dataToExport, "LeloForms_data.xlsx");

      // Log export activity
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }

      await axios.post(`${appUrl}/api/dataexport`, {
        user_name: user?.name,
        azure_id: user?.azureID,
        fileName: "LeloForms_data.xlsx",
        recordCount: dataToExport.length,
        screen: "Secondary Enrollments Admin Screen",
        exportType: "excel",
        exportStatus: "success",
      });

    } catch (error) {
      console.error("Error during export:", error);
      toast.error("Failed to export data. Please try again.");

      // Log failed export
      try {
        if (localStorage.token) {
          setAuthToken(localStorage.token);
        }
        await axios.post(`${appUrl}/api/dataexport`, {
          user_name: user?.name,
          azure_id: user?.azureID,
          fileName: "LeloForms_data.xlsx",
          recordCount: 0,
          screen: "Secondary Enrollments Admin Screen",
          exportType: "excel",
          exportStatus: "failed",
        });
      } catch (logError) {
        console.error("Error logging failed export:", logError);
      }
    } finally {
      setIsExporting(false);

      // Call parent's onExportComplete callback to hide the message
      if (onExportComplete) {
        onExportComplete();
      }
    }
  };

  return (
    <>
      <button
        className={`btn btn-llac-dark-green btn-export1`}
        onClick={handleExport}
        disabled={isExporting}
      >
        {isExporting ? "Exporting..." : "Export to Excel"}
      </button>
    </>
  );
};

export default ExportExcelButton;